export default {
  // 5 mb en base64
  MAX_DOCUMENT_SIZE: 7182745
};
